var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    id: "clipboard_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clipboard_svg__cls-1{fill:none;stroke:#292d32;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard_svg__document-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "clipboard_svg__Vector",
    className: "clipboard_svg__cls-1",
    d: "M18 14h4c2 0 2-1 2-2 0-2-1-2-2-2h-4c-1 0-2 0-2 2s1 2 2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clipboard_svg__Vector-2",
    className: "clipboard_svg__cls-1",
    d: "M24 12.02c3.33.18 5 1.41 5 5.98v6c0 4-1 6-6 6h-6c-5 0-6-2-6-6v-6c0-4.56 1.67-5.8 5-5.98"
  }))));
};
export default SvgClipboard;